class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.showArticle = this.hasAttribute('data-show-article');
    this.showPage = this.hasAttribute('data-show-page');
    this.limit = this.hasAttribute('data-limit') ? this.getAttribute('data-limit') : 4;
    this.hideProduct = this.hasAttribute('data-hide-product');

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    let resourceTypes = []; // default resource type
  
    if (!this.hideProduct) {
      resourceTypes.push('product');
    }
  
    if (this.showArticle) {
      resourceTypes.push('article');
    }
  
    if (this.showPage) {
      resourceTypes.push('page');
    }

    const resources = resourceTypes.join(',');
  
    fetch(`/search/suggest?q=${searchTerm}&resources[type]=${resources}&resources[limit]=${this.limit}&resources[limit_scope]=each&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
  
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);

class FadeMessages extends HTMLElement {
  constructor() {
    super();
    this.messages = this.querySelectorAll('.js-fade-message');
    this.transitionSeconds = this.hasAttribute('data-transtition-seconds') ? parseInt(this.getAttribute('data-transtition-seconds')) : 5;
    this.currentMessageIndex = 0;
    setInterval(() => {
      this.messages[this.currentMessageIndex].classList.remove('active');
      this.currentMessageIndex = (this.currentMessageIndex + 1) % this.messages.length;
      this.messages[this.currentMessageIndex].classList.add('active');
    }, this.transitionSeconds * 1000);
  }
}

customElements.define('fade-messages', FadeMessages);